import moment from 'moment';

import { campaignLineStatuses } from '../../campaign-editor/constants';
import { allStatusesEnum } from '../../campaigns/constants';
import { INTERNAL_DATE_FORMAT } from '../../utils/constants';
import EndCampaignForm from './EndCampaignForm';

export default {
  label: 'End Campaign',
  value: 'End Campaign',
  Form: EndCampaignForm,
  initialState() {
    return {
      proposedEndDate: moment().format(INTERNAL_DATE_FORMAT),
    };
  },
  patch: (campaign, change, campaignLines) => {
    const proposedEndDate = moment(change.proposedEndDate).format(
      INTERNAL_DATE_FORMAT,
    );

    const filterCampaignLinesInFuture = campaignLine =>
      moment(proposedEndDate).isBefore(campaignLine.startDate) &&
      [campaignLineStatuses.PUSHED, campaignLineStatuses.LOCKED].includes(
        campaignLine.status,
      );

    const filterCampaignLines = campaignLine =>
      moment(proposedEndDate).isBefore(campaignLine.endDate) &&
      moment(proposedEndDate).isAfter(campaignLine.startDate) &&
      [campaignLineStatuses.PUSHED, campaignLineStatuses.LOCKED].includes(
        campaignLine.status,
      );

    // Only those campaign lines which have end date beyond the proposed end date
    // and statuses with Pushed, Locked would need to be limited.
    const campaignLinesToBeEnded = Object.values(campaignLines)
      .map(item => ({
        id: item.id,
        endDate: item.endDate,
        status: item.status,
        startDate: item.startDate,
      }))
      .filter(filterCampaignLines);

    // Gets the campaign lines that have start dates in the future
    const campaignLinesInFutureToBeEnded = Object.values(campaignLines)
      .map(item => ({
        id: item.id,
        endDate: item.endDate,
        status: item.status,
        startDate: item.startDate,
      }))
      .filter(filterCampaignLinesInFuture);

    const campaignLinesIdsToBeEnded = campaignLinesToBeEnded.map(cl => cl.id);
    const campaignLinesInFutureIdsToBeEnded =
      campaignLinesInFutureToBeEnded.map(cl => cl.id);

    return {
      // passes the proposed end date for cl which has end date after the proposed one.
      // passes the proposed end date as start and end dates for cl which are in future.
      // for the other cl just the id needs to be passed as such
      campaignLines: [
        ...campaignLinesToBeEnded.map(cl => ({
          id: cl.id,
          endDate: proposedEndDate,
        })),
        ...campaignLinesInFutureToBeEnded.map(cl => ({
          id: cl.id,
          endDate: proposedEndDate,
          startDate: proposedEndDate,
        })),
        ...Object.values(campaignLines)
          .filter(cl => !campaignLinesIdsToBeEnded.includes(cl.id))
          .filter(cl => !campaignLinesInFutureIdsToBeEnded.includes(cl.id))
          .map(item => ({ id: item.id })),
      ],
      status: allStatusesEnum.ENDING_REQUESTED.value,
    };
  },
};
